import "./about.css";
import swimming from "../image/swimming.png";
import cooking from "../image/cooking.png";
import travelling from "../image/waiting-room.png";
import music from "../image/music.png";
import carousel_bg from "./carousel-wave.svg";
import { useState } from "react";

export const AboutPage = () => {
  const [carousel_translate, set_carousel_translate] = useState(0);

  const carousel_width = 900;
  const carousel_item_count = 2;

  const handleLeftArrowClick = () => {
    set_carousel_translate(carousel_translate + carousel_width);
  };

  const handleRightArrowClick = () => {
    set_carousel_translate(carousel_translate - carousel_width);
  };

  return (
    <div className="aboutContainer" id="about">
      {/* <div className="spaceDiv"></div> */}

      <div className="headingBtn">
        <p className="heading">About Myself</p>
        <div></div>
      </div>

      {/* <div className="aboutDescription">
        <p data-aos="fade-up">
          Learning new technology and creating user-friendly apps with
          innovation are the two key areas I always eye upon. A passionate Full
          Stack Web Developer, I never stop growing with coding.
        </p>
      </div> */}

      <div className="about-info">
        <div
          className="carousel-container"
          style={{
            // backgroundImage: `url(${carousel_bg})`,
            width: `${carousel_width}px`,
          }}
        >
          <button
            disabled={carousel_translate === 0 ? true : false}
            className="carousel-arrow left"
            onClick={() => handleLeftArrowClick()}
          >
            ➤
          </button>
          <button
            disabled={
              carousel_translate ===
              -1 * (carousel_width * (carousel_item_count - 1))
                ? true
                : false
            }
            className="carousel-arrow right"
            onClick={() => handleRightArrowClick()}
          >
            ➤
          </button>
          <div
            className="carousel-item-container"
            style={{
              transform: `translate(${carousel_translate}px, 0px)`,
              width: `${carousel_width * carousel_item_count}px`,
            }}
          >
            <div className="carousel-item" disable>
              <p>
                Learning new technology and creating user-friendly apps with
                innovation are the two key areas I always eye upon. A passionate
                Full Stack Web Developer, I never stop growing with coding.
              </p>
            </div>
            <div className="carousel-item">
              <p>
                Currently I'm working as a Software Engineer at Attosol pvt lmd.
                I have 1 year of solid experience in working in Frontend
                technologies here. For the first few months I have worked on
                Hugo. Then I started working on the company product BakeMyWeb,
                which is built in React.
              </p>
              <p>
                I have worked on both Class based and Function based components.
                optimized some old code. Made some old component reusable.
                Integrated API to build new features such as nested menu
                listing, create, move file folders.
              </p>
              <p>
                Later I have learned Slate Js. I have worked on some main
                features of the BakeMyWeb Editor. Currently I have quite a grasp
                on Slate Js.
              </p>
              <p>
                I have worked solo on Blob Maker, which is a tool of BakeMyWeb.
                You can create svg various patterns in a few clicks using the
                tool.
              </p>
            </div>
          </div>
        </div>
      </div>

      <p className="interestedP">
        The things I'm interested in apart from coding are...
      </p>

      <div className="hobbies">
        <div>
          <div data-aos="fade-left">
            <div className="bullet"></div>
            <p>Music</p>
            {/* <img className="hobby_icon" src={music} alt="" /> */}
          </div>
          <div data-aos="fade-right">
            <div className="bullet"></div>
            <p>Travelling</p>
            {/* <img className="hobby_icon" src={travelling} alt="" /> */}
          </div>
        </div>

        <div>
          <div data-aos="fade-left">
            <div className="bullet"></div>
            <p>Cooking</p>
            {/* <img className="hobby_icon" src={cooking} alt="" /> */}
          </div>
          <div data-aos="fade-right">
            <div className="bullet"></div>
            <p>Swimming</p>
            {/* <img className="hobby_icon" src={swimming} alt="" /> */}
          </div>
        </div>
      </div>
    </div>
  );
};
